import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";

const hint = (s) => [s.last_visit && `last visit ${fmtDate(s.last_visit)}`, s.date_of_birth && `DOB ${fmtDate(`${s.date_of_birth}T12:00:00`)}`,
  `${s.visit_count} visits`].filter(Boolean).join(" · ");

export const MatchSuggestions = ({ med, suggestions = [] }) => {
  const qc = useQueryClient();
  const link = useMutation({ mutationFn: (s) => api.post(`/medications/${med.id}/link`, { patient_id: s.id }),
    onSuccess: (res, s) => { toast.success(`Matched ${res.data.linked} note${res.data.linked === 1 ? "" : "s"} to ${s.name}`); qc.invalidateQueries({ queryKey: ["medications"] }); qc.invalidateQueries({ queryKey: ["med-suggestions"] }); qc.invalidateQueries({ queryKey: ["notifications"] }); },
    onError: () => toast.error("Could not match") });
  if (!suggestions.length) return null;

  return (
    <div className="mt-1 flex flex-wrap items-center gap-1" data-testid={`med-suggestions-${med.id}`}>
      <span className="text-[11px] text-slate-400">Did you mean</span>
      {suggestions.map((s) => (
        <button key={s.id} type="button" disabled={link.isPending} title={hint(s)} onClick={() => link.mutate(s)}
          data-testid={`med-suggest-${med.id}-${s.id}`}
          className="whitespace-nowrap rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 disabled:opacity-50">
          {s.name}<span className="ml-1 hidden font-normal text-emerald-600 sm:inline">{s.last_visit ? `· ${fmtDate(s.last_visit)}` : `· ${s.visit_count} visits`}</span>
        </button>
      ))}
    </div>
  );
};
